/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { MultilineLabel } from 'src/modules/labeling/types/Label';
import { Rect } from 'src/modules/labeling/types/Rect';
import { ShapeUIProps } from 'src/modules/labeling/types/ShapeUIProps';
import { shapeClassName } from 'src/modules/labeling/utils/labelingConstants';

/**
 * Converts a label to a shape with the help of tokenRects.
 */
export const mapLabelToShape = (tokenRects: Rect[], isRTL: boolean, absoluteStartTokenIndex: number) => (
    label: MultilineLabel
): ShapeUIProps => {
    const {
        start: labelStart,
        end: labelEnd,
        entity,
        role,
        depth,
        renderingLevel,
        hasBorderEnd,
        hasBorderStart,
        renderedAs,
        line,
        originalLabel
    } = label;
    const { start, height, top } = tokenRects[(isRTL ? labelEnd : labelStart) - absoluteStartTokenIndex];
    const { start: endTokenStart, width } = tokenRects[(isRTL ? labelStart : labelEnd) - absoluteStartTokenIndex];

    const key = `Shape(coordinates=(${top},${endTokenStart},${height},${start}),originalRange=(${originalLabel.intrinsicStart},${originalLabel.intrinsicEnd}),name=${entity.name},id=${entity.id},role=${role}, type=${renderedAs})`;

    return {
        tokenHeight: height,
        className: shapeClassName,
        entityType: entity.typeId,
        depth,
        end: endTokenStart + width,
        hasBorderEnd,
        hasBorderStart,
        key,
        label,
        renderingLevel,
        renderedAs,
        line,
        name: `${entity.name}${role ? `:${role.name}` : ''}`,
        start,
        top,
        associatedTokenIndex: Math.floor((labelEnd - labelStart) / 2) + labelStart
    };
};
